export default "__VITE_ASSET__CyCIZtCf__"